/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {
    Pagination,
    Tag,
    Checkbox,
    Tooltip,
    Spin,
    Divider,
    Button,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import IconEmpty from '../../../assets/Images/icons/empty';
import { useEffect, useState } from 'react';
import { DeleteOutlined, DownloadOutlined } from '@ant-design/icons';
import RopaService from '../../../services/Ropa.service';
import useNotify from '../../../context/Notification/useNotify';
import ModalDelete from '../../../components/Shared/modal/delete';
import moment from 'moment';
import { ROUTER } from '../../../constants/router';
import usePermission from '../../../hooks/usePermission';

export default function ListCard({
    loadingData,
    currentPage,
    setCurrentPage,
    dataSource,
    total,
    search,
    setLoading,
    select,
    setSelect,
    dataSelection,
    setDataSelection,
    checkedAll,
    setCheckedAll,
    isCheckedAll,
    setIsCheckedAll,
    setAllSelection,
    allSelection,
    allDataSelection,
    setAllDataSelection,
}) {
    const { t } = useTranslation();

    const notify = useNotify();

    const [openDelete, setOpenDelete] = useState(false);
    const [loading, setLoading_] = useState(false);

    const { isAuditor } = usePermission();

    const deleteListActivity = () => {
        setLoading_(true);
        setTimeout(async () => {
            try {
                const { data } = await RopaService.deleteListActivity({
                    ids: select,
                });
                if (data?.resultCode === 1) {
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully deleted data'),
                    });
                    setLoading_(false);
                    setOpenDelete(false);
                    setSelect([]);
                    setDataSelection([]);
                    setTimeout(async () => {
                        search();
                    }, 1000);
                } else {
                    setLoading_(false);
                    setOpenDelete(false);
                    notify({
                        type: 'error',
                        title: t('common.Fail'),
                        description: t('RoPA.FailedToDeleted'),
                    });
                }
            } catch (error) {
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('RoPA.FailedToDeleted'),
                });
                setLoading_(false);
                setOpenDelete(false);
            }
        }, 1200);
    };

    const exportListActivity = () => {
        setLoading_(true);
        setTimeout(async () => {
            try {
                const res = await RopaService.exportListActivity({
                    activityIds: select,
                    isAll: isCheckedAll,
                });
                const objectURL = window.URL.createObjectURL(
                    new Blob([res?.data])
                );
                const link = document.createElement('a');
                link.href = objectURL;
                link.download = `ropa_report_export${moment(new Date()).format(
                    '_DDMMYYYYhhmmss'
                )}.xlsx`;
                document.body.appendChild(link);
                link.click();
                link.parentNode.removeChild(link);
            } catch (error) {
                console.log(error);
                notify({
                    type: 'error',
                    title: t('common.Fail'),
                    description: t('RoPA.FailedToDownloaded'),
                });
                setLoading_(false);
            }
        }, 1200);
    };

    const validateDelete = () => {
        const _caseDelete = ['Draft', 'Revise'];
        const _caseDefault = ['Waiting for Review', 'Reviewed'];
        const _checkDelCase = dataSelection?.filter((result) =>
            _caseDelete.includes(result.statusEn)
        );
        const _checkDefaultCase = dataSelection?.filter((result) =>
            _caseDefault.includes(result.statusEn)
        );
        return _checkDelCase.length > 0 && _checkDefaultCase.length === 0;
    };

    // CheckAll
    useEffect(() => {
        let selectAll = dataSource.map((data) => data.activityId);
        let count = 0;
        select?.forEach((res, i) => {
            if (selectAll.includes(res)) {
                count += 1;
            }
        });
        if (count === dataSource?.length && selectAll.length !== 0) {
            setCheckedAll(true);
        } else {
            setCheckedAll(false);
        }
    }, [currentPage.page, select, dataSource]);

    useEffect(() => {
        let selectAll = dataSource.map((data) => data.activityId);
        // Select Per Page
        const selectPerPage = [];
        const dataSelectionPerPage = [];
        allSelection?.forEach((res) => {
            if (selectAll.includes(res)) {
                selectPerPage.push(res);
            }
        });
        allDataSelection?.forEach((res) => {
            if (selectAll.includes(res?.activityId)) {
                dataSelectionPerPage.push(res);
            }
        });
        setSelect(selectPerPage);
        setDataSelection(dataSelectionPerPage);
    }, [dataSource]);

    return (
        <>
            <div className="grid gap-3">
                <div className="px-4">
                    {dataSource?.length > 0 && (
                        <div className="flex space-x-4 bg-white w-full py-4 px-3 rounded-lg ">
                            <div className="flex items-center h-full">
                                <Checkbox
                                    checked={checkedAll}
                                    onClick={(e) => {
                                        setCheckedAll(e.target.checked);
                                        let selectAll = dataSource.map(
                                            (data) => data.activityId
                                        );

                                        let IsSelectAll = allSelection;

                                        let IsDataSelection = allDataSelection;
                                        // All Data Select
                                        selectAll?.forEach((res, i) => {
                                            if (!IsSelectAll.includes(res)) {
                                                IsSelectAll.push(res);
                                            }
                                        });
                                        dataSource?.forEach((res, i) => {
                                            if (
                                                !IsDataSelection.includes(res)
                                            ) {
                                                IsDataSelection.push(res);
                                            }
                                        });
                                        // Select Per Page
                                        let allSelectPerPage = [];
                                        let allDataSelectionPerPage = [];
                                        IsSelectAll?.forEach((res, i) => {
                                            if (selectAll.includes(res)) {
                                                allSelectPerPage.push(res);
                                            }
                                        });
                                        IsDataSelection?.forEach((res, i) => {
                                            if (
                                                selectAll.includes(
                                                    res?.activityId
                                                )
                                            ) {
                                                allDataSelectionPerPage.push(
                                                    res
                                                );
                                            }
                                        });

                                        if (e.target.checked) {
                                            setSelect(allSelectPerPage);
                                            setAllSelection(IsSelectAll);
                                            setAllDataSelection(
                                                allDataSelectionPerPage
                                            );
                                            setDataSelection(IsDataSelection);
                                        } else {
                                            setIsCheckedAll(false);
                                            let itemSelect = allSelection;
                                            let itemDataSelecttion =
                                                allDataSelection;
                                            // All Data Select
                                            selectAll?.forEach((res, i) => {
                                                let set = itemSelect.filter(
                                                    (data) => data !== res
                                                );
                                                itemSelect = set;
                                            });
                                            dataSource?.forEach((res, i) => {
                                                let set =
                                                    itemDataSelecttion.filter(
                                                        (data) =>
                                                            data?.activityId !==
                                                            res?.activityId
                                                    );
                                                itemDataSelecttion = set;
                                            });

                                            // Select Per Page
                                            const selectPerPage = [];
                                            const dataSelectionPerPage = [];
                                            itemSelect?.forEach((res) => {
                                                if (selectAll.includes(res)) {
                                                    selectPerPage.push(res);
                                                }
                                            });
                                            itemDataSelecttion?.forEach(
                                                (res) => {
                                                    if (
                                                        selectAll.includes(res)
                                                    ) {
                                                        dataSelectionPerPage.push(
                                                            res
                                                        );
                                                    }
                                                }
                                            );
                                            setSelect(selectPerPage);
                                            setAllSelection(itemSelect);
                                            setDataSelection(
                                                dataSelectionPerPage
                                            );
                                            setAllDataSelection(
                                                itemDataSelecttion
                                            );
                                        }
                                    }}
                                />
                            </div>
                            <div className="font-semibold text-sm flex w-full  items-center">
                                <div className="whitespace-nowrap flex space-x-2 items-center">
                                    <span>
                                        {t('RoPA.SelectAll')} (
                                        {isCheckedAll ? total : select.length})
                                    </span>
                                    {/* {select.length > 0 && (

                            )} */}
                                    <div className="flex items-center space-x-2">
                                        <Button
                                            disabled={
                                                !validateDelete() || isAuditor
                                            }
                                            icon={<DeleteOutlined />}
                                            onClick={(e) => setOpenDelete(true)}
                                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-error text-sm"
                                        ></Button>
                                        <Button
                                            disabled={select.length === 0}
                                            icon={<DownloadOutlined />}
                                            onClick={() => {
                                                exportListActivity();
                                            }}
                                            className="bg-[#F3F6F9] h-8 w-8 flex items-center justify-center rounded-lg text-purple text-sm"
                                        ></Button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
                <Spin spinning={loadingData} size="large">
                    <div className="overflow-auto max-h-[58vh] grid gap-3 px-4 pb-4">
                        {dataSource.length > 0 ? (
                            dataSource?.map((item) => (
                                <Card
                                    dataSource={dataSource}
                                    setDataSelection={setDataSelection}
                                    setSelect={setSelect}
                                    setAllSelection={setAllSelection}
                                    allSelection={allSelection}
                                    allDataSelection={allDataSelection}
                                    setAllDataSelection={setAllDataSelection}
                                    item={item}
                                    select={select}
                                    dataSelection={dataSelection}
                                    checkedAll={checkedAll}
                                    setCheckedAll={setCheckedAll}
                                    currentPage={currentPage}
                                    total={total}
                                    setIsCheckedAll={setIsCheckedAll}
                                />
                            ))
                        ) : (
                            <div className="grid items-center justify-center">
                                <IconEmpty />
                            </div>
                        )}
                    </div>
                </Spin>
            </div>
            {dataSource?.length > 0 && (
                <div className="w-full text-right mt-4">
                    <Pagination
                        current={currentPage?.page || 1}
                        pageSizeOptions={[10, 20, 30]}
                        defaultPageSize={10}
                        total={currentPage?.total || 1}
                        onChange={(page, pageSize) => {
                            const pageValue = {
                                ...currentPage,
                                page: page,
                                pageSize: pageSize,
                            };
                            setLoading(true);
                            setCurrentPage(pageValue);
                            setIsCheckedAll(false);
                            setSelect([]);
                            setDataSelection([]);
                            setCheckedAll(false);
                        }}
                        showSizeChanger
                    />
                </div>
            )}
            <ModalDelete
                loading={loading}
                open={openDelete}
                text={t('RoPA.DoYouWantDeleteRoPA', { length: select?.length })}
                handelOk={deleteListActivity}
                handelClose={() => setOpenDelete(false)}
            />
        </>
    );
}

const Card = ({
    checkedAll,
    setCheckedAll,
    setIsCheckedAll,
    item,
    select,
    setSelect,
    dataSelection,
    setDataSelection,
    currentPage,
    total,
    setAllSelection,
    allSelection,
    allDataSelection,
    setAllDataSelection,
    dataSource,
}) => {
    const { t, i18n } = useTranslation();
    const { isAuditor } = usePermission();
    const _getTagPersonalData = (item, itemAddon, dataName) => {
        let list = [];
        if (dataName === 'personalData') {
            item?.forEach((res) => {
                list.push(
                    i18n.language === 'en'
                        ? res.personalDataOptionEn
                        : res.personalDataOptionTh
                );
            });
        } else {
            item?.forEach((res) => {
                list.push(
                    i18n.language === 'en'
                        ? res.sensitivePersonalDataOptionEn
                        : res.sensitivePersonalDataOptionTh
                );
            });
        }
        const personalData = list?.concat(itemAddon);

        return (
            <>
                {personalData && personalData.length > 0 ? (
                    <>
                        {personalData?.map((item, index) => {
                            if (index < 2) {
                                return (
                                    <>
                                        <Tag
                                            style={{
                                                backgroundColor:
                                                    dataName === 'personalData'
                                                        ? '#DFF3FC'
                                                        : '#FFF7E6',
                                                color:
                                                    dataName === 'personalData'
                                                        ? '#1890FF'
                                                        : '#FF6E04',
                                                border: '0px',
                                                borderRadius: '17px',
                                                overflow: 'hidden',
                                                whiteSpace: 'nowrap',
                                                textOverflow: 'ellipsis',
                                                maxWidth: '364px',
                                            }}
                                        >
                                            <div
                                                style={{
                                                    overflow: 'hidden',
                                                    whiteSpace: 'nowrap',
                                                    textOverflow: 'ellipsis',
                                                    maxWidth: '364px',
                                                }}
                                            >
                                                <Tooltip
                                                    className="cursor-pointer"
                                                    placement="topLeft"
                                                    title={<>{item}</>}
                                                >
                                                    {item}
                                                </Tooltip>
                                            </div>
                                        </Tag>
                                    </>
                                );
                            }
                        })}
                        {personalData.length > 2 && (
                            <Tooltip
                                overlayStyle={{ minWidth: '18%' }}
                                title={
                                    <div>
                                        <>
                                            {personalData?.map(
                                                (item, index) => (
                                                    <li className="list-disc">
                                                        {item}
                                                    </li>
                                                )
                                            )}
                                        </>
                                    </div>
                                }
                                placement="bottom"
                            >
                                <Tag
                                    className="cursor-pointer"
                                    style={{
                                        backgroundColor: '#B2B2B2',
                                        color: '#FFFFFF',
                                        border: '0px',
                                        borderRadius: '17px',
                                        overflow: 'hidden',
                                        whiteSpace: 'nowrap',
                                        textOverflow: 'ellipsis',
                                    }}
                                >
                                    +{personalData.length - 2}
                                </Tag>
                            </Tooltip>
                        )}
                    </>
                ) : (
                    <>-</>
                )}
            </>
        );
    };

    const _getTagStatus = (e) => {
        switch (e) {
            case 'Draft':
                return { color: '#65707A', borderColor: '#65707A' };
            case 'Waiting for Review':
                return { color: '#F9C153', borderColor: '#F9C153' };
            case 'Reviewed':
                return { color: '#4ACE8F', borderColor: '#4ACE8F' };
            case 'Revise':
                return { color: '#F0536F', borderColor: '#F0536F' };
            default:
                return { color: '#FFF', background: '' };
        }
    };

    return (
        <div className="flex bg-white w-full py-4 px-3 rounded-lg space-x-3 transform duration-300 hover:scale-[1.01] border-hover">
            <div className="flex items-center h-full mr-3">
                <Checkbox
                    checked={select.find((s) => s === item.activityId)}
                    onClick={(e) => {
                        if (e.target.checked) {
                            let selectAll = dataSource.map(
                                (data) => data.activityId
                            );
                            let allSelectData = [
                                ...allSelection,
                                item.activityId,
                            ];
                            let selectData = [];
                            allSelectData?.forEach((res) => {
                                if (selectAll?.includes(res)) {
                                    selectData.push(res);
                                }
                            });
                            let allSelectDataSelection = [
                                ...allDataSelection,
                                item,
                            ];
                            let dataSelectionData = [];
                            allSelectDataSelection?.forEach((res) => {
                                if (selectAll?.includes(res?.activityId)) {
                                    dataSelectionData.push(res);
                                }
                            });
                            setSelect(selectData);
                            setAllSelection(allSelectData);
                            setDataSelection(dataSelectionData);
                            setAllDataSelection(allSelectDataSelection);
                            if (
                                select.length + 1 === currentPage.pageSize ||
                                select.length + 1 === total
                            ) {
                                setCheckedAll(true);
                            }
                        } else {
                            setSelect(
                                select.filter(
                                    (data) => data !== item.activityId
                                )
                            );
                            setAllSelection(
                                allSelection.filter(
                                    (data) => data !== item.activityId
                                )
                            );
                            setDataSelection(
                                dataSelection.filter(
                                    (data) =>
                                        data.activityId !== item.activityId
                                )
                            );
                            setAllDataSelection(
                                allDataSelection.filter(
                                    (data) =>
                                        data.activityId !== item.activityId
                                )
                            );
                            setCheckedAll(false);
                            setIsCheckedAll(false);
                        }
                    }}
                />
            </div>
            <div className="w-full">
                <Link
                    to={`${ROUTER.DS_INVENTORY.ROPA}/${item.activityId}/view`}
                >
                    <a className="font-semibold text-sm text-purple">
                        {item?.activityName || '-'}
                    </a>
                </Link>
                <div className="font-semibold">
                    {t('This activity is under the task')} :{' '}
                    {item?.businessProcessName}
                </div>
                <div>{item?.businessProcessFullName || '-'}</div>
                <Divider className="my-2" />
                <div className="grid grid-cols-7 mt-2">
                    <div className="space-y-2 col-span-3">
                        <div className="grid grid-cols-1 text-xs">
                            <div className="flex">
                                <strong className="text-xs w-1/4">
                                    {t('RoPA.Department')} :
                                </strong>
                                <div className="flex-auto w-3/4">
                                    {i18n.language === 'en'
                                        ? item?.departmentEn
                                        : item?.departmentTh}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 text-xs">
                            <div className="flex">
                                <strong className="text-xs w-1/4">
                                    {t('RoPA.status')} :
                                </strong>
                                <div className="flex-auto w-3/4">
                                    {item?.statusEn ? (
                                        <Tag
                                            className="rounded-xl -my-1 text-center"
                                            style={_getTagStatus(
                                                item?.statusEn
                                            )}
                                        >
                                            {i18n?.language === 'en'
                                                ? item?.statusEn || '-'
                                                : item?.statusTh || '-'}
                                        </Tag>
                                    ) : (
                                        <>-</>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 text-xs">
                            <div className="flex">
                                <strong className="text-xs w-1/4">
                                    {t('RoPA.UpdateDate')} :
                                </strong>
                                <div className="flex-auto w-3/4">
                                    {item?.modifyDate || '-'}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="space-y-2 col-span-4">
                        <div className="grid grid-cols-1 text-xs">
                            <div className="flex">
                                <strong className="text-xs w-1/4">
                                    {t('RoPA.personalData')} :
                                </strong>
                                {/* <div>{item.personalData?.join(', ')}</div> */}
                                <div className="flex-auto w-3/4">
                                    {_getTagPersonalData(
                                        item?.personalData,
                                        item?.personalDataAddOn,
                                        'personalData'
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="grid grid-cols-1 text-xs">
                            <div className="flex">
                                <strong className="text-xs w-1/4">
                                    {t('RoPA.sensitivePersonalDataOption')} :
                                </strong>
                                {/* <div>{item.sensitivePersonalData?.join(', ')}</div> */}
                                <div className="flex-auto w-3/4">
                                    {_getTagPersonalData(
                                        item?.sensitivePersonalData,
                                        item?.sensitivePersonalDataAddOn,
                                        'sensitivePersonalData'
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
